import * as React from "react"
import {Box, Typography} from '@mui/material'
import {formatPrice} from "@ui-seeker/utils";

import {NotAllowedBlock} from "@components";
import {TABS_OFFERS} from "../../../@constants";


export default function diffCompetitorColumn(title) {

    const DiscountBackground = ({ discount, children }) => {
        const backgroundColor=discount >= 0 ? 'success.light' : 'error.light'
        return <Box component="span" sx={{ p: 1, borderRadius: 1.2, backgroundColor: backgroundColor }}>
            {children}
        </Box>
    }

    return {
        name: 'Diff PVR Competitor',
        label: title === TABS_OFFERS.DRUNI ? 'Druni VS Primor' : 'Primor vs Druni',
        options: {
            customBodyRowRenderLite: (value, row) => {
                return <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center', gap: 0.5 }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Diferencia PVR:</Typography>
                        <Typography variant="body2" sx={{ ml: 1 }}>
                            {value !== 0 && <DiscountBackground discount={value}>
                                {value + '%'}
                            </DiscountBackground>}
                            {value === 0 && <NotAllowedBlock sx={{ ml: 1 }} />}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Diferencia PVP:</Typography>
                        <Typography variant="body2" sx={{ ml: 1 }}>
                            {row['Diff PVP Competitor'] !== 0 && <DiscountBackground discount={row['Diff PVP Competitor']}>
                                {row['Diff PVP Competitor'] + '%'}
                            </DiscountBackground>}
                            {row['Diff PVP Competitor'] === 0 && <NotAllowedBlock sx={{ ml: 1 }} />}
                        </Typography>
                    </Box>

                </Box>
            }
        }
    }
}